import { render, staticRenderFns } from "./StoreMessages.vue?vue&type=template&id=f65f7054&scoped=true&lang=pug"
import script from "./StoreMessages.vue?vue&type=script&lang=js"
export * from "./StoreMessages.vue?vue&type=script&lang=js"
import style0 from "./StoreMessages.vue?vue&type=style&index=0&id=f65f7054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65f7054",
  null
  
)

export default component.exports